import React from 'react';
import { IQuickFilterContext } from 'framework/IQuickFilterContext';
import { ITableViewContext } from 'framework/table/ITableViewContext';
import { IPurchase, PurchaseExportProp } from 'gen/ApiClient';
import { QuickFilter } from '../PurchasesCard';
import { SelectableColumn } from '../SelectableColumn';

interface IViewContext extends ITableViewContext<SelectableColumn, IPurchase>, IQuickFilterContext<QuickFilter> {
	exportRecord: Record<PurchaseExportProp, string>;
}

export const ViewContext = React.createContext<IViewContext>(undefined as any);
